import React, { useState } from 'react';
import { Button, ButtonGroup } from '@mui/material';
import TickerCalendar from '../TickerCalendar/TickerCalendar';
import NewsCollection from '../News/NewsCollection';

const NewsAndEvents = () => {
  const [activeTab, setActiveTab] = useState('1');

  const handleButtonClick = (key) => {
    setActiveTab(key);
  };

  return (
    <div className={'w-full pt-2 flex flex-col items-center'}>
      <ButtonGroup className={'mb-4'} size="large">
        <Button
          onClick={() => handleButtonClick('1')}
          className={activeTab === '1' ? '' : 'bg-white text-black hover:bg-gray-200'}
          variant={activeTab === '1' ? 'contained' : 'outlined'}
          sx={{
            px: 8,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            ...(activeTab === '1' && {
              zIndex: 1, // Ensure active button is on top
            }),
          }}
        >
          News
        </Button>
        <Button
          onClick={() => handleButtonClick('2')}
          className={activeTab === '2' ? '' : 'bg-white text-black hover:bg-gray-200'}
          variant={activeTab === '2' ? 'contained' : 'outlined'}
          sx={{
            px: 8,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            ...(activeTab === '2' && {
              zIndex: 1,
            }),
          }}
        >
          Events
        </Button>
      </ButtonGroup>

      <div className={'w-full'}>
        {activeTab === '1' && <NewsCollection />}
        {activeTab === '2' && (
          <div className={'p-6'}>
            <TickerCalendar />
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsAndEvents;